import { ObservableFromFetch } from "../ObservableFromFetch"

export interface CompanyPool {
  PoolID: number
  PoolName: string
}

export default function CompanyPoolsGet(testEventId: number) {
  const requestBody: string = JSON.stringify({
    TestEventID: testEventId
  })
  return ObservableFromFetch<CompanyPool[]>("WorkforceRandomTest/GetCompanyPools", requestBody)
}
